import type { Contact } from '@/shared/types/api'

export type ContactToVCardOverrides = Partial<{
  statusMessage: string
}>

const escapeVCardValue = (value: string): string =>
  value.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,')

export const contactToVCard = (contact: Contact, overrides?: ContactToVCardOverrides): string => {
  const lines: string[] = ['BEGIN:VCARD', 'VERSION:3.0']

  const fn = contact.name?.trim() || 'Unknown'
  lines.push(`FN:${escapeVCardValue(fn)}`)

  const familyName = contact.lastName ?? ''
  const givenName = contact.firstName ?? ''
  const middleName = contact.middleName ?? ''
  const n = [familyName, givenName, middleName, '', ''].map(escapeVCardValue).join(';')
  lines.push(`N:${n}`)

  if (contact.internalNumber?.trim()) {
    lines.push(`TEL;TYPE=WORK,VOICE:${contact.internalNumber.trim()}`)
  }
  if (contact.mobilePhone?.trim()) {
    lines.push(`TEL;TYPE=CELL:${contact.mobilePhone.trim()}`)
  }
  if (contact.imLogin?.trim()) {
    const imLogin = contact.imLogin.trim()
    const impp = imLogin.startsWith('<') && imLogin.endsWith('>')
      ? imLogin.slice(1, -1)
      : imLogin
    lines.push(`IMPP:${escapeVCardValue(impp)}`)
  }
  if (contact.email?.trim()) {
    lines.push(`EMAIL:${contact.email.trim()}`)
  }
  if (contact.organization?.trim() || contact.organizationalUnit?.trim()) {
    const org = [contact.organization?.trim() ?? '', contact.organizationalUnit?.trim() ?? '']
      .filter(Boolean)
      .map(escapeVCardValue)
      .join(';')
    lines.push(`ORG:${org}`)
  }
  if (contact.position?.trim()) {
    lines.push(`TITLE:${escapeVCardValue(contact.position.trim())}`)
  }
  if (contact.bDay?.trim()) {
    const bday = contact.bDay.trim()
    lines.push(`BDAY:${bday.includes('T') ? bday.slice(0, 10) : bday}`)
  }
  const statusMessage = overrides?.statusMessage?.trim()
  if (statusMessage) {
    lines.push(`NOTE:${escapeVCardValue(statusMessage)}`)
  }

  lines.push('END:VCARD')
  return lines.join('\r\n')
}
